import { render, staticRenderFns } from "./diagnosisSet.vue?vue&type=template&id=16c5bad6&scoped=true&"
import script from "./diagnosisSet.vue?vue&type=script&lang=js&"
export * from "./diagnosisSet.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisSet.vue?vue&type=style&index=0&id=16c5bad6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5bad6",
  null
  
)

export default component.exports